// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ribbon{right:0;height:135px;min-width:35px;bottom:45%;padding:0;background:#a870ff;border:2px solid #d4b8ff;border-radius:16px 0 0 16px;color:#fff;z-index:200}#ribbon .v-btn__content{writing-mode:vertical-rl;font-size:12px}.on-hover-underline:hover{text-decoration:underline!important}a.v-breadcrumbs__item:hover{text-decoration:underline}.v-autocomplete:not(.v-input--is-focused).v-select--chips input{max-height:25px!important}", ""]);
// Exports
module.exports = exports;
